import React, { Component } from 'react';
import Gnb from '../components/Gnb';
import Immutable from 'immutable';
import NotFound from '../components/ErrorContent/NotFound';

export default class NotFoundPage extends Component {

  render() {
    const { device } = this.props;
    return (
      <div style={{ height: '100%' }}>
        <div id="kakaoIndex">
          <a href="#kakaoBody">본문 바로가기</a>
          <a href="#kakaoGnb">메뉴 바로가기</a>
        </div>
        <div id="kakaoWrap">
          <Gnb device={Immutable.Map()}/>
          <NotFound device={device} />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/NotFoundPage.js